import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { SeriesFilterTypesEnum } from '../enums/series-filter-types.enum';
import { SeriesPickerFieldModel } from './series-picker-field.model';
import { mentionSeriesTypes, SeriesTypeEnum, socialSeriesTypes } from '../enums/series-type.enum';

export class SeriesPickerCompareFieldModel implements SeriesPickerFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    typeOptions: SeriesTypeEnum[];
    tooltipMessage: string[];

    maxNumberOfSeries: number = 12;
    multiSeries: boolean = true;
    isBarChart: boolean = false;

    filters = [
        SeriesFilterTypesEnum.keywords,
        SeriesFilterTypesEnum.authors,
        SeriesFilterTypesEnum.outlets,
        SeriesFilterTypesEnum.audience,
        SeriesFilterTypesEnum.ave,
        SeriesFilterTypesEnum.sentiment,
        SeriesFilterTypesEnum.mediaTypes,
        SeriesFilterTypesEnum.country,
        SeriesFilterTypesEnum.province,
        SeriesFilterTypesEnum.province,
        SeriesFilterTypesEnum.regions,
        SeriesFilterTypesEnum.languages,
        SeriesFilterTypesEnum.duplicates,
        SeriesFilterTypesEnum.aiAgents,
        SeriesFilterTypesEnum.tags,
        SeriesFilterTypesEnum.tagGroups,
        SeriesFilterTypesEnum.sourceGroups
    ];

    showColorSwatch: boolean;
    required: boolean;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        typeOptions: SeriesTypeEnum[] = [...mentionSeriesTypes, ...socialSeriesTypes],
        tooltipMessage?: string[],
        showColorSwatch: boolean = false,
        isBarChart: boolean = false,
        required: boolean = false,
        headingId?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.typeOptions = typeOptions;
        this.tooltipMessage = tooltipMessage;
        this.showColorSwatch = showColorSwatch;
        this.isBarChart = isBarChart;
        this.required = required;
        this.headingId = headingId;
    }
}
